/**
 * @generated SignedSource<<59bb80d8cbe391419ce31c5ca8d91d7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemCondition_viewer$data = {
  readonly itemConditionsList: ReadonlyArray<{
    readonly description: string | null;
    readonly title: string | null;
  } | null> | null;
  readonly " $fragmentType": "ItemCondition_viewer";
};
export type ItemCondition_viewer$key = {
  readonly " $data"?: ItemCondition_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemCondition_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vertical"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./ItemConditionRefetchQuery.graphql')
    }
  },
  "name": "ItemCondition_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "vertical",
          "variableName": "vertical"
        }
      ],
      "concreteType": "ItemConditionDisplay",
      "kind": "LinkedField",
      "name": "itemConditionsList",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1d852a9bd7a8ab7d2387437929b07d18";

export default node;
